import React, { createContext, useContext, useEffect, useState } from 'react';
import { BASE_WEBSOCKET_URL } from 'util/api/client';
import isBrowser from 'util/isBrowser';

const ActionCableContext = createContext();

const ActionCableProvider = ({ children }) => {
  const [consumer, setConsumerInstance] = useState(null);
  if (!isBrowser()) {
    return children;
  }

  useEffect(() => {
    const createConsumer = require('@rails/actioncable').createConsumer;
    const token = localStorage.getItem('access_token');

    if (!token) return;

    const url = `${BASE_WEBSOCKET_URL}?token=${token}&employer_profile_id=${localStorage.getItem(
      'current_employer_profile_id',
    )}`;

    setConsumerInstance(createConsumer(url));

    return () => consumer?.disconnect();
  }, []);

  return <ActionCableContext.Provider value={{ consumer }}>{children}</ActionCableContext.Provider>;
};

const useWebsocket = (channel, params = {}, callback) => {
  if (!isBrowser()) {
    return;
  }

  const context = useContext(ActionCableContext);
  if (!context) {
    throw new Error('useWebsocket must be used within a ActionCableProvider');
  }
  const { consumer } = context;

  useEffect(() => {
    if (!consumer) {
      return;
    }
    const subscription = consumer.subscriptions.create(
      {
        channel,
        ...params,
      },
      {
        received: (data) => {
          callback(data);
        },
      },
    );
    return () => subscription && consumer.subscriptions.remove(subscription);
  }, [JSON.stringify(params), consumer]);
};

export { ActionCableProvider, useWebsocket };
